import { TabulatorGrid } from './Tabulator';

export function LoadTabulator() {

    (window as any).TabulatorEngine = {
        createGridByRef: function (ref: any, context: any) {
            let grid = new TabulatorGrid().createGridByRef(ref, context);
            (window as any).ItemsManager.add(ref, grid);
        },

        destroyGridByRef: function (ref: any) {
            let manager = (window as any).ItemsManager;
            let grid = manager.get(ref);
            manager.remove(ref);
            grid?.destroyGrid();
        },

        updateContextByRef: function (ref: any, context: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.updateContext(context);
        },

        updateHeaderRowByRef: function (ref: any, headerRow: string) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.updateHeaderRow(headerRow);
        },

        updateHeaderColumnByRef: function (ref: any, headerColumn: string) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.updateHeaderColumn(headerColumn);
        },

        setMultipleSorterByRef: function (ref: any, orderdFields: any ) {
            let grid = (window as any).ItemsManager.get(ref);
            if (grid) {
                grid.setMultipleSorter(orderdFields);
            }
        },        

        setColumnsByRef: function (ref: any, columns: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.setColumns(columns);
        },

        setDataByRef: function (ref: any, data: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.setData(data);
        },

        setPivotDataSourceByRef: function (ref: any, data: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.setPivotDataSource(data);
        },

        exportByRef: function (ref: any, fileName: string) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.export('xlsx', fileName);
        },

        сopyDataToClipboardByRef: function (ref: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.сopyDataToClipboard();
        },

        resizeToParentByRef: function (ref: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.resizeToParent();
        },
   
        setSelectedRowByRef: function (ref: any, index: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.setSelectedRow(index);
        },

        setSelectedRowsByRef: function (ref: any, indices: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.setSelectedRows(indices);
        },

        setSelectedDataByRef: function (ref: any, rows: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.setSelectedData(rows);
        },

        setIsSelectingByRef: function (ref: any, isSelecting: boolean) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.setIsSelecting(isSelecting);
        },

        showNoRowsOverlayByRef(ref: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.showNoRowsOverlay();
        },

        showLoaderOverlayByRef(ref: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.showLoaderOverlay();
        },

        hideLoaderOverlayByRef(ref: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.hideLoaderOverlay();
        },

        deselectAllRowsByRef(ref: any) {
            let grid = (window as any).ItemsManager.get(ref);
            grid?.deselectAllRows();
        }
    }
}